const FormResources = {

    form_data:{
        name:           '',
        abbreviation:   '',
        sq_footage:     ''
    },

    form_data_note: {
        title:          '',
        content:        '',
        creation_date:  ''
    },

    form_format:[
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Name:',
            model_name: 'name',
            ref:        'name_input',
            ref_alt:    'name_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Abbreviation:',
            model_name: 'abbreviation',
            ref:        'abbreviation_input',
            ref_alt:    'abbreviation_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-6',
            type:       'number',
            maxlength:  365,
            disabled:   true,
            step:       '',
            name:       'Sq. Footage:',
            model_name: 'sq_footage',
            ref:        'sq_footage_input',
            ref_alt:    'sq_footage_input_alt',
            required:   false,
        },
    ],

    form_format_note:[
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  45,
            disabled:   false,
            step:       '',
            name:       'Title:',
            model_name: 'title',
            ref:        'title_input',
            ref_alt:    'title_input_alt',
            required:   true,
        },
        {
            css_class:  'col-md-12',
            type:       'textarea',
            maxlength:  245,
            disabled:   false,
            step:       '',
            name:       'Content:',
            model_name: 'content',
            ref:        'content_input',
            ref_alt:    'content_input_alt',
            required:   true,
        },
    ],

}

export default FormResources;